import {createListenerMiddleware} from '@reduxjs/toolkit';

import {getMobileLineApi, getMobileLinesUsageApi} from './mobileLines';

export const mobileLineListenerMiddleware = createListenerMiddleware();

mobileLineListenerMiddleware.startListening({
	actionCreator: getMobileLineApi.fulfilled,
	effect:        async (_action, listenerApi) => {
		listenerApi.dispatch(getMobileLinesUsageApi());
	}
});